import { createApp } from 'vue';
import HeroSection from './components/HeroSection.vue';
import HomeProductFeed from './components/HomeProductFeed.vue';
import SectionGallery from './pages/SectionGallery.vue';
import ProductPageSection from './pages/Product.vue';
import ContactSection from './pages/Contact.vue';
import axios from 'axios';

window.axios = axios;

// Initialize your Vue 3 instance
const app = createApp({
    data() {
        return {
            isMenuOpen: false
        };
    },
    watch: {
        isMenuOpen(newValue) {
            if (newValue) {
                document.body.classList.add('menu-lock');
            } else {
                document.body.classList.remove('menu-lock');
            }
        }
    }
});

app.component('hero-section', HeroSection);
app.component('home-product-feed', HomeProductFeed);
app.component('section-gallery', SectionGallery);
app.component('product-page-section', ProductPageSection);
app.component('contact-section', ContactSection);

app.mount('#app');